import Page from "src/components/common/Page";
import React, { FC, useEffect, useState } from "react";
import { useApi } from "src/Api/useApi";
import TrainingSummaryList from "./TrainingSummaryList";
import { IOrganizationTrainingSummary } from "src/@types/ImpiricaPlatformApi";
import { Button, Form } from "antd";
import { FormComponentProps } from "antd/lib/form";
import styles from "./OrganizationTrainingSummary.module.scss";

interface IProps extends FormComponentProps {
	match?: any;
}

const OrganizationTrainingSummaryScreen: FC<IProps> = ({ match }) => {
	const { trainingCourseClient } = useApi();
	const [loading, setLoading] = useState(false);
	const url = { organizationId: Number(match.params.organizationId) };
	const [orgTrainingSummary, setOrgTrainingSummary] =
		useState<IOrganizationTrainingSummary>();
	const [showAll, setShowAll] = useState(false);

	useEffect(() => {
		const init = async () => {
			setLoading(true);
			await loadUsers();
			setLoading(false);
		};
		init();
	}, []);

	const loadUsers = async () => {
		if (trainingCourseClient) {
			try {
				const orgTrainingSummary =
					await trainingCourseClient.getOrganizationTrainingSummary(
						url.organizationId
					);
				setOrgTrainingSummary(orgTrainingSummary);
			} catch (e) {
				console.log(e);
			}
		}
	};

	const onShowAllClick = () => {
		setShowAll(!showAll);
	};

	return (
		<Page title="Training Summary">
			<div className={styles.container}>
				<div className={styles.buttonContainer}>
					<Button
						className="btn-primary"
						onClick={onShowAllClick}
						loading={loading}
					>
						{showAll ? "Show Active" : "Show All"}
					</Button>
				</div>

				{orgTrainingSummary &&
					orgTrainingSummary.users &&
					orgTrainingSummary.users.length > 0 && (
						<TrainingSummaryList
							organizationId={url.organizationId}
							orgTrainingSummary={orgTrainingSummary}
							showAll={showAll}
						/>
					)}
			</div>
		</Page>
	);
};

export default Form.create<IProps>()(OrganizationTrainingSummaryScreen);
